import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { RadioImageButton } from '../../../../common/inputs/radioButton/radioButton';
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import useApi from "../../../../../hooks/useApi";
import externalApiService from "../../../../../services/externalApiService";
import authService from "../../../../../services/authService";

const ConnectModal = ({
  show,
  onHide,
  accountingSoftwares,
  selectedAccSw,
  setSelectedAccSw,
  entityGuid,
  productId
}) => {

   const { constants } = authService.getCurrentUser();

   const accSwConnectApi = useApi(externalApiService.accSwConnect);

   const confirmConnection = () => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
              <div className="custom-delete-ui">
                <h6>Connect to {selectedAccSw}</h6>
                <p>You are about to be redirected to {selectedAccSw}'s website to authenticate your account.
                   After successful authentication, you’ll be redirected back automatically.
                   Would you like to proceed?</p>
                <button
                    className="btn btn-white"
                    onClick={() => { onClose(); }}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-primary ml-2"
                    onClick={connectWithAccSw}
                >
                    Proceed
                </button>
              </div>
            );
          },
          title: "",
          message: ``,
      });
    };

    const RETURN_URL_MAP = {
      [constants.PRODUCTS.SUPPLYCHAIN]: "/client/scf/dashboard",
      [constants.PRODUCTS.TRADEFINANCE]: "/client/tf/dashboard",
      [constants.PRODUCTS.INVOICE]: "/client/if/dashboard", 
    };

    const connectWithAccSw = async () => {
      const returnUrl = !productId
        ? "/client/accounting-software"
        : RETURN_URL_MAP[productId] || "/client/accounting-software";

      const response = await accSwConnectApi.request({
          entityId: entityGuid,
          api_type: selectedAccSw,
          return_url : returnUrl
      });
      if (response) {
          if (response.data.success == true) {
              window.location.href = response.data.authUrl;
          } else {
              toast.error("Failed to authenticate with " + selectedAccSw);
          }
      }
    };

  return (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <h4 className="modal-title">Let's Connect</h4>
    </Modal.Header>
    <Modal.Body>
      <div className="ml-3">
        <label className="control-label mb-2">
          Please select an accounting software and connect
        </label>
        {accountingSoftwares.map((itm, index) => (
          <RadioImageButton
            key={`${itm.value}_${index}`}
            name="acc_sw_type"
            value={itm.value}
            id={`${itm.value}_${index}`}
            imgsrc={itm.img_link}
            label={itm.label}
            onChange={(e) => setSelectedAccSw(e.target.value)}
          />
        ))}
        <button
          className="btn btn-primary float-right mt-1"
          onClick={confirmConnection}
          disabled={!selectedAccSw}
        >
          Connect
        </button>
      </div>
    </Modal.Body>
  </Modal>
)}

export default ConnectModal;
